import React from 'react';
import { Box, Stack } from '@mui/material';
import { FacilityReportSummaryView, FacilityCenterBreakdownView, FacilityIssueTypeBreakdownView } from '../../../../../services/ReportingService';
import { TicketsByLocationChart, TicketsByIssueTypeChart, StaffVsVendorChart, CostOverviewChart } from '../../charts';

interface WorkOrderReportChartsProps {
  summaryData: FacilityReportSummaryView;
  centerData: FacilityCenterBreakdownView[];
  issueTypeData: FacilityIssueTypeBreakdownView[];
}

const WorkOrderReportCharts: React.FC<WorkOrderReportChartsProps> = ({
  summaryData,
  centerData,
  issueTypeData,
}) => {
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mb: 3 }}>
      <Stack spacing={3} direction={{ xs: 'column', md: 'row' }}>
        <TicketsByLocationChart centerData={centerData} />
        <TicketsByIssueTypeChart issueTypeData={issueTypeData} />
      </Stack>

      <Stack spacing={3} direction={{ xs: 'column', md: 'row' }}>
        <StaffVsVendorChart summaryData={summaryData} />
        <CostOverviewChart centerData={centerData} />
      </Stack>
    </Box>
  );
};

export default WorkOrderReportCharts;
